// src/locales/si/courierInvoice.js
export const courierInvoice = {
  // Page Titles
  uploadInvoice: "කුරියර් ඉන්වොයිසය Upload කරන්න",
  allInvoices: "කුරියර් ඉන්වොයිස්",
  invoiceDetails: "ඉන්වොයිස් විස්තර",

  // Form Fields
  selectCourierAccount: "කුරියර් ගිණුම තෝරන්න",
  courierAccount: "කුරියර් ගිණුම",
  invoiceNumber: "ඉන්වොයිස් අංකය",
  invoiceDate: "ඉන්වොයිස් දිනය",
  uploadFile: "ෆයිල් Upload කරන්න",

  // File Upload
  dropFileHere: "ඔබගේ ෆයිලය මෙතනට ඇද දමන්න හෝ click කරන්න",
  supportsFiles: ".xlsx, .xls, .csv ෆයිල් ලබා දිය හැක",
  selectFile: "ෆයිල් තෝරන්න",
  fileSelected: "ෆයිල් තෝරා ඇත",
  removeFile: "ෆයිල් ඉවත් කරන්න",

  // Column Mapping
  columnMapping: "Column Mapping",
  columnMappingLoaded: "Column mapping load වී ඇත",
  mappingWarnings: "Column Mapping අවවාද",
  missingColumn: "අවශ්‍ය Column එක නොමැත",
  downloadTemplate: "Template එක Download කරන්න",

  // File Preview
  filePreview: "ෆයිල් Preview",
  firstRows: "මුල් පේළි 5",

  // Eligible Orders
  eligibleOrders: "ප්‍රමාණ අවසර Orders",
  totalValue: "මුළු වටිනාකම",

  // Processing
  startProcessing: "Process කිරීම ආරම්භ කරන්න",
  processing: "Process වෙමින් පවතී",
  processingInvoice: "ඉන්වොයිස් Process වෙමින් පවතී",
  processingChunk: "Chunk process වෙමින් පවතී",
  ordersProcessed: "orders process විය",
  pauseUpload: "Pause කරන්න",
  resumeUpload: "නැවත ආරම්භ කරන්න",
  cancelUpload: "Upload අවලංගු කරන්න",

  // Progress Stats
  matched: "Matched",
  notFound: "Not Found",
  alreadyInvoiced: "දැනටමත් Invoiced",
  ineligible: "අවසර නොමැති",
  errors: "Errors",

  // Results
  processingComplete: "Process කිරීම සම්පුර්ණයි",
  totalOrders: "මුළු Orders",
  delivered: "Delivered",
  returned: "Returned",
  financialSummary: "Financial Summary",
  codCollected: "COD එකතු කළ මුදල",
  courierCharges: "කුරියර් ගාස්තු",
  netAmountPayable: "ගෙවිය යුතු මුළු මුදල",

  // Actions
  viewInvoiceDetails: "ඉන්වොයිස් විස්තර බලන්න",
  uploadAnotherInvoice: "වෙනත් ඉන්වොයිස් Upload කරන්න",
  downloadErrorReport: "Error Report Download කරන්න",
  reprocessFailed: "Failed orders නැවත process කරන්න",
  deleteInvoice: "ඉන්වොයිස් Delete කරන්න",

  // Messages
  invoiceUploadedSuccessfully: "ඉන්වොයිස් සාර්ථකව process විය!",
  invoiceUploadCancelled: "Upload කිරීම අවලංගු කරන ලදි",
  failedToLoadCouriers: "කුරියර් ගිණුම් Load කිරීමට අවලංගු විය",
  failedToLoadMapping: "Column mapping load කල නොහැකි විය",
  invalidFileType: "කරුණාකර වලංගු Excel හෝ CSV ෆයිලයක් Upload කරන්න",
  fileMustHaveData: "ෆයිලයේ අනුපිළිවෙල සහ දත්ත තිබිය යුතුය",
  failedToReadFile: "ෆයිලය කියවීමට නොහැකි විය",
  selectCourierFirst: "පළමුව කුරියර් ගිණුම තෝරන්න",
  enterInvoiceNumber: "ඉන්වොයිස් අංකය ඇතුල් කරන්න",
  selectInvoiceDate: "ඉන්වොයිස් දිනය තෝරන්න",
  uploadFileFirst: "පළමුව ෆයිලය Upload කරන්න",
  mappingWarningsConfirm: "Column mapping warning(s) ඇත. ඉදිරියට යාමට අවශ්‍යද?",
  cancelUploadConfirm: "Upload අවලංගු කරන්නද?",
  failedToStartUpload: "Upload ආරම්භ කිරීම අසාර්ථකයි",
  failedToUploadChunk: "Chunk upload කිරීමට නොහැකි විය",
  failedToFinalizeInvoice: "ඉන්වොයිස් finalize කිරීමට නොහැකි විය",
  failedToCancelInvoice: "Upload අවලංගු කිරීමට නොහැකි විය",

  // Invoice List
  searchByInvoice: "ඉන්වොයිස් අංකයෙන් search කරන්න",
  filterByStatus: "තත්ත්වයෙන් Filter කරන්න",
  filterByDate: "දිනයෙන් Filter කරන්න",
  invoiceNumberCol: "Invoice #",
  courierCompany: "කුරියර් සමාගම",
  invoiceDateCol: "ඉන්වොයිස් දිනය",
  totalOrdersCol: "මුළු Orders",
  matchedOrdersCol: "Matched",
  statusCol: "තත්වය",
  uploadedBy: "Upload කළේ",
  uploadedOn: "Upload කළ දිනය",
  actions: "ක්‍රියා",

  // Invoice Status
  pending: "Pending",
  processing: "Processing",
  completed: "Completed",
  failed: "Failed",
  partiallyProcessed: "අර්ධ වශයෙන් Process විය",

  // Invoice Details
  invoiceInformation: "ඉන්වොයිස් තොරතුරු",
  ordersSummary: "Orders සාරාංශය",
  deliveryBreakdown: "Delivery Breakdown",
  matchStatusBreakdown: "Match Status Breakdown",
  discrepancies: "විෂමතා",
  invoiceOrders: "Invoice orders",

  // Order Match Status
  matchStatus: "Match Status",
  orderMatched: "Matched",
  orderNotFound: "Not Found",
  orderAlreadyInvoiced: "Already Invoiced",
  orderIneligible: "Ineligible",

  // Delivery Status
  deliveryStatus: "Delivery Status",
  deliveryDelivered: "Delivered",
  deliveryReturned: "Returned",
  deliveryInTransit: "In Transit",
  deliveryOther: "Other",

  // Filters
  allStatuses: "සියලු තත්ව",
  allDeliveryStatuses: "සියලු Delivery තත්ව",
  allMatchStatuses: "සියලු Match තත්ව",
  applyFilters: "Filter Lagu කරන්න",
  resetFilters: "Filters Reset කරන්න",

  // Empty States
  noInvoicesYet: "ඉන්වොයිස් නොමැත",
  uploadFirstInvoice: "පළමු ඉන්වොයිස් Upload කරන්න",
  noOrdersFound: "Orders නොමැත",
  noDiscrepanciesFound: "විෂමතා නොමැත",

  // Validation
  invoiceNumberRequired: "ඉන්වොයිස් අංකය අවශ්‍යයි",
  courierAccountRequired: "කුරියර් ගිණුම අවශ්‍යයි",
  invoiceDateRequired: "ඉන්වොයිස් දිනය අවශ්‍යයි",
  fileRequired: "ෆයිල් අවශ්‍යයි",
  invalidInvoiceDate: "ඉන්වොයිස් දිනය අනාගත දිනයක් විය නොහැක",

  // Error Details
  errorFound: "Error(s) හමුවිය",
  rowNumber: "Row #",
  airwaybillNumber: "Airwaybill #",
  errorMessage: "Error message",

  // Statistics
  successRate: "Success Rate",
  totalInvoices: "සියලු ඉන්වොයිස්",
  totalOrdersProcessed: "Process කළ Orders",
  totalValueProcessed: "Process කළ මුළු වටිනාකම",

  // Reprocessing
  reprocessing: "Reprocessing",
  reprocessingComplete: "Reprocess කිරීම සම්පුර්ණයි",
  ordersReprocessed: "Orders Reprocess විය",
  successfullyReprocessed: "සාර්ථකව Reprocess විය",
  stillFailed: "තවම Failed",

  // Confirmations
  deleteInvoiceConfirm: "ඉන්වොයිස් Delete කරන්නද?",
  reprocessFailedConfirm: "Failed orders සියල්ල නැවත process කරන්නද?",

  // Export
  exportInvoice: "Invoice Export කරන්න",
  exportOrders: "Orders Export කරන්න",
  exportDiscrepancies: "Discrepancies Export කරන්න",

  // Details Page - Header
  backToInvoices: "ඉන්වොයිස් වෙත ආපසු",
  invoiceTitle: "Invoice {{number}}",
  uploadedByUser: "Uploaded by {{user}}",
  downloadPDF: "PDF Download කරන්න",
  reprocessFailedOrders: "Failed orders Reprocess කරන්න",
  cancel: "අවලංගු කරන්න",
  delete: "Delete කරන්න",

  // Details Page - Summary Cards
  matchedOrders: "Matched Orders",

  // Details Page - Tabs
  overview: "Overview",
  ordersTab: "Orders ({{count}})",
  discrepanciesTab: "Discrepancies ({{count}})",
  timeline: "Timeline",

  // Details Page - Overview Tab
  financialBreakdown: "Financial Breakdown",
  totalCodCollected: "මුළු COD එකතුව",
  totalCourierCharges: "මුළු කුරියර් ගාස්තු",
  processingMetadata: "Processing Metadata",
  fileName: "ෆයිල් නම",
  fileSize: "ෆයිල් ප්‍රමාණය",
  rowsInFile: "ෆයිල් Row ගණන",
  processingTime: "Processing දී ගත වූ කාලය",
  seconds: "තත්පර",

  // Details Page - Orders Tab
  searchByAirwaybill: "Airwaybill අංකයෙන් search කරන්න...",
  loadingOrders: "Orders Load වෙමින්...",
  noOrdersMatchFilters: "Filters වලට ගැලපෙන Orders නොමැත",
  orderNumber: "Order Number",
  customerName: "Customer නම",
  shop: "Shop",
  codAmount: "COD මුදල",
  courierCharge: "කුරියර් ගාස්තුව",
  amountPayable: "ගෙවිය යුතු මුදල",
  viewDetails: "විස්තර බලන්න",
  showingOrders: "{{from}} - {{to}} / {{total}} Orders",

  // Details Page - Discrepancies Tab
  problemOrdersRequiringAttention: "සැලකිලිමත් විය යුතු Orders",
  downloadReport: "Report Download කරන්න",
  allOrdersMatched: "සියලු Orders Match වී ඇත",
  notFoundInSystem: "System හි නොමැත ({{count}})",
  reprocessAll: "සියල්ල Reprocess කරන්න",
  airwaybill: "Airwaybill",
  error: "Error",
  alreadyInvoicedGroup: "දැනටමත් Invoiced ({{count}})",
  order: "Order",
  ineligibleOrdersGroup: "අවසර නොමැති Orders ({{count}})",

  // Details Page - Timeline Tab
  invoiceCreated: "Invoice නිර්මාණය කරන ලදි",
  invoiceInitializedBy: "Invoice initialize කළේ {{user}}",
  invoiceNumberLabel: "ඉන්වොයිස් අංකය",
  expectedOrders: "Expected orders",
  processingStarted: "Processing ආරම්භ විය",
  startedProcessingInvoice: "Invoice processing ආරම්භ විය",
  chunksUploaded: "Chunks upload විය",
  chunksCount: "{{received}} / {{expected}} chunks",
  orderDataUploadedInBatches: "Order data batches ලෙස upload විය",
  processingCompleted: "Processing සම්පුර්ණයි",
  invoiceFinalizedWithStatus: "Invoice Finalized - {{status}}",
  processingTimeDuration: "Processing කාලය: {{seconds}}s",
  lastUpdated: "අවසන් Update",
  mostRecentModification: "Invoice වෙත අවසන් Update",

  // Details Page - Order Modal
  orderDetails: "Order විස්තර",
  invoiceData: "Invoice Data",
  systemOrderData: "System Order Data",
  customer: "Customer",
  grandTotal: "Grand Total",
  noMatchingOrderFound: "System Order නොමැත",

  // Details Page - Confirmation Modal
  cancelButton: "Cancel",
  confirm: "Confirm",
  cancelInvoiceTitle: "Invoice අවලංගු කරන්න",
  cancelInvoiceConfirm: "Invoice Cancel කිරීමෙන් order updates rollback වේ",
  deleteInvoiceTitle: "Invoice Delete කරන්න",

  // Details Page - Error Messages
  failedToLoadInvoice: "Invoice load කිරීමට නොහැකි විය",
  failedToLoadOrders: "Orders load කිරීමට නොහැකි විය",
  failedToLoadDiscrepancies: "Discrepancies load කිරීමට නොහැකි විය",
  failedToReprocessOrders: "Reprocess කිරීමට නොහැකි විය",
  actionFailed: "Action අසාර්ථකයි",
  invoiceNotFound: "Invoice නොමැත",
  loadingInvoiceDetails: "Invoice විස්තර load වෙමින්...",

  // Details Page - Success Messages
  ordersReprocessedSuccess: "{{count}} orders Reprocess විය",
  invoiceCancelledSuccess: "Invoice අවලංගු විය",
  invoiceDeletedSuccess: "Invoice Deleted විය",

  // Create Page - Header
  uploadAndProcessInvoices: "කුරියර් ඉන්වොයිස් Upload & Process කරන්න",

  // Create Page - Courier Selection
  courierAccountSelection: "කුරියර් ගිණුම තෝරාගැනීම",
  courierAccountLabel: "කුරියර් ගිණුම *",

  // Create Page - Invoice Form
  invoiceNumberLabel: "ඉන්වොයිස් අංකය *",
  invoiceDateLabel: "ඉන්වොයිස් දිනය *",
  enterInvoiceNumberPlaceholder: "ඉන්වොයිස් අංකය ඇතුල් කරන්න",

  // Create Page - File Upload
  uploadInvoiceFile: "ඉන්වොයිස් ෆයිල් Upload කරන්න",
  ordersCount: "Orders {{count}}",
  columnMappingWarnings: "Column Mapping අවවාද ({{count}})",
  filePreviewTitle: "File Preview (මුල් පේළි 5)",
  missingRequiredColumn: "අවශ්‍ය Column එක නොමැත: \"{{column}}\" - \"{{field}}\"",

  // Create Page - Progress
  processingChunkProgress: "Chunk {{current}} / {{total}} Process වෙමින්...",
  ordersProcessedProgress: "{{processed}} / {{total}} orders Process වෙමින්...",

  // Create Page - Results
  errorsFound: "{{count}} Errors හමුවිය",

  // List Page - Main
  manageAndTrackInvoices: "සියලු කුරියර් ඉන්වොයිස් කළමනාකරණය & Track කරන්න",

  // List Page - Filters
  allCouriers: "සියලු කුරියර්",
  searchByInvoice: "ඉන්වොයිස් අංකයෙන් search කරන්න...",

  // List Page - Empty States
  noInvoicesFound: "ඉන්වොයිස් නොමැත",
  noInvoicesFoundDescription: "Filters වලට ගැලපෙන ඉන්වොයිස් නොමැත",
  uploadFirstInvoiceDescription: "පළමු ඉන්වොයිස් Upload කරන්න",

  // List Page - Bulk Actions
  deleteSelected: "තෝරාගත් {{count}} Delete කරන්න",
  confirmBulkDelete: "{{count}} ඉන්වොයිස් Delete කරන්නද?",
  bulkDeleteSuccess: "{{count}} ඉන්වොයිස් Delete විය",
  bulkDeleteFailed: "{{count}} ඉන්වොයිස් Delete කිරීමට අසාර්ථකයි",
  failedToBulkDelete: "Bulk delete අසාර්ථකයි",

  // List Page - Actions
  cancelInvoice: "Invoice අවලංගු කරන්න",
  failedToLoadInvoices: "ඉන්වොයිස් load කිරීමට අසාර්ථකයි",
  failedToCancel: "Invoice cancel කිරීමට අසාර්ථකයි",
  failedToDelete: "Invoice delete කිරීමට අසාර්ථකයි",

  // Modal - Titles & Actions
  cancelInvoiceTitle: "Invoice අවලංගු කරන්න",
  deleteInvoiceTitle: "Invoice Delete කරන්න",
  confirmCancel: "Invoice අවලංගු කරන්න",
  confirmDelete: "Invoice Delete කරන්න",
  cancelWarning: "මේ සඳහා Order updates rollback වේ",
  deleteWarning: "මෙය යථා තත්වයට නැවත ලබා ගත නොහැක",

  // Common
  amountPayable: "ගෙවිය යුතු මුදල",

  // Flags
  flagsTab: "Flags ({{count}})",
  flaggedOrders: "Flagged Orders",
  filterUnresolved: "Unresolved",
  filterResolved: "Resolved",
  filterAll: "All",
  recheckFlags: "Re-check Flags",
  flagsRechecked: "Checked {{checked}} orders, {{flagged}} flagged",
  failedToRecheckFlags: "Failed to re-check flags",
  failedToLoadFlags: "Failed to load flags",
  noFlags: "No flagged orders",
  flagReason_cod_mismatch: "COD Mismatch",
  flagReason_weight_mismatch: "Weight Mismatch",
  flagReason_delivery_charge_mismatch: "Delivery Charge Mismatch",
  flagReason_return_charge_mismatch: "Return Charge Mismatch",
  flagReason_paid_amount_mismatch: "Paid Amount Mismatch",
  flagReason_check_error: "Check Error",
  allFlagReasons: "All Flag Reasons",
  weight: "Weight (kg)",
  searchByAirwaybillOrOrder: "Search by airwaybill or order number...",
  flagExpectedVsInvoice: "Expected {{expected}} / Invoice {{actual}}",
  resolve: "Resolve",
  resolveFlagTitle: "Resolve Flag - {{airwaybill}}",
  resolveNote: "Resolve Note",
  resolveNotePlaceholder: "Explain how this was resolved...",
  resolvedByOn: "Resolved by {{user}} on {{date}}",
  flagResolved: "Flag resolved successfully",
  failedToResolveFlag: "Failed to resolve flag",
  flagReasonsColumn: "Flag Reasons",
  resolveNoteColumn: "Resolve Note",
  resolvedByOnShort: "by {{user}} · {{date}}"
};
